export const RECEIVE_ACCESS_TOKEN = "RECEIVE_ACCESS_TOKEN";
export const RECEIVE_GA_CLIENT_ID = "RECEIVE_GA_CLIENT_ID";

export const ACCESS_TOKEN_FAILURE = "ACCESS_TOKEN_FAILURE";

export const ACTION_STORE_FETCH_REQUEST = "ACTION_STORE_FETCH_REQUEST";
export const ACTION_STORE_FETCH_SUCCESS = "ACTION_STORE_FETCH_SUCCESS";
export const ACTION_STORE_FETCH_FAILURE = "ACTION_STORE_FETCH_FAILURE";

export const ATTENDEES_REQUEST = "ATTENDEES_REQUEST";
export const ATTENDEES_SUCCESS = "ATTENDEES_SUCCESS";
export const ATTENDEES_FAILURE = "ATTENDEES_FAILURE";

export const ATTENDEE_CREATE_REQUEST = "ATTENDEE_CREATE_REQUEST";
export const ATTENDEE_CREATE_SUCCESS = "ATTENDEE_CREATE_SUCCESS";
export const ATTENDEE_CREATE_FAILURE = "ATTENDEE_CREATE_FAILURE";

export const ATTENDEE_CREATE_INVITE_REQUEST = "ATTENDEE_CREATE_INVITE_REQUEST";
export const ATTENDEE_CREATE_INVITE_SUCCESS = "ATTENDEE_CREATE_INVITE_SUCCESS";
export const ATTENDEE_CREATE_INVITE_FAILURE = "ATTENDEE_CREATE_INVITE_FAILURE";

export const ATTENDEE_CLEAR_INVITE_COUNT = "ATTENDEE_CLEAR_INVITE_COUNT";

export const ATTENDEE_UPDATE_REQUEST = "ATTENDEE_UPDATE_REQUEST";
export const ATTENDEE_UPDATE_SUCCESS = "ATTENDEE_UPDATE_SUCCESS";
export const ATTENDEE_UPDATE_FAILURE = "ATTENDEE_UPDATE_FAILURE";

export const PROFILE_REQUEST = "PROFILE_REQUEST";
export const PROFILE_SUCCESS = "PROFILE_SUCCESS";
export const PROFILE_FAILURE = "PROFILE_FAILURE";

export const ENTITLEMENTS_FETCH_REQUEST = "ENTITLEMENTS_FETCH_REQUEST";
export const ENTITLEMENTS_FETCH_SUCCESS = "ENTITLEMENTS_FETCH_SUCCESS";
export const ENTITLEMENTS_FETCH_FAILURE = "ENTITLEMENTS_FETCH_FAILURE";

export const PROFILE_CREATE_REQUEST = "PROFILE_CREATE_REQUEST";
export const PROFILE_CREATE_SUCCESS = "PROFILE_CREATE_SUCCESS";
export const PROFILE_CREATE_FAILURE = "PROFILE_CREATE_FAILURE";

export const PROFILE_TRANSACT_REQUEST = "PROFILE_TRANSACT_REQUEST";
export const PROFILE_TRANSACT_SUCCESS = "PROFILE_TRANSACT_SUCCESS";
export const PROFILE_TRANSACT_FAILURE = "PROFILE_TRANSACT_FAILURE";

export const PROFILE_UPDATE_REQUEST = "PROFILE_UPDATE_REQUEST";
export const PROFILE_UPDATE_SUCCESS = "PROFILE_UPDATE_SUCCESS";
export const PROFILE_UPDATE_FAILURE = "PROFILE_UPDATE_FAILURE";

export const SESSION_CREATE_REQUEST = "SESSION_CREATE_REQUEST";
export const SESSION_CREATE_SUCCESS = "SESSION_CREATE_SUCCESS";
export const SESSION_CREATE_FAILURE = "SESSION_CREATE_FAILURE";

export const MESSAGE_COUNT_REQUEST = "MESSAGE_COUNT_REQUEST";
export const MESSAGE_COUNT_SUCCESS = "MESSAGE_COUNT_SUCCESS";
export const MESSAGE_COUNT_FAILURE = "MESSAGE_COUNT_FAILURE";

export const SET_NAV_STEP = "SET_NAV_STEP";
export const CLEAR_NAV_STEP = "CLEAR_NAV_STEP";

export const BOOKING_UPDATE_REQUEST = "BOOKING_UPDATE_REQUEST";
export const BOOKING_UPDATE_SUCCESS = "BOOKING_UPDATE_SUCCESS";
export const BOOKING_UPDATE_FAILURE = "BOOKING_UPDATE_FAILURE";

export const BOOKING_UPDATE_SHARE_STATE_REQUEST =
  "BOOKING_UPDATE_SHARE_STATE_REQUEST";
export const BOOKING_UPDATE_SHARE_STATE_SUCCESS =
  "BOOKING_UPDATE_SHARE_STATE_SUCCESS";
export const BOOKING_UPDATE_SHARE_STATE_FAILURE =
  "BOOKING_UPDATE_SHARE_STATE_FAILURE";

export const BOOKING_FETCH_REQUEST = "BOOKING_FETCH";
export const BOOKING_FETCH_SUCCESS = "BOOKING_SUCCESS";
export const BOOKING_FETCH_FAILURE = "BOOKING_FETCH_FAILURE";
export const BOOKING_FORM_SUBMITTED = "BOOKING_FORM_SUBMITTED";
export const RESET_BOOKING_STORE = "RESET_BOOKING_STORE";

export const BOOKING_PREPARE_REQUEST = "BOOKING_PREPARE_REQUEST";
export const BOOKING_PREPARE_SUCCESS = "BOOKING_PREPARE_SUCCESS";
export const BOOKING_PREPARE_FAILURE = "BOOKING_PREPARE_FAILURE";

export const BOOKING_CREATE_REQUEST = "BOOKING_CREATE_REQUEST";
export const BOOKING_CREATE_SUCCESS = "BOOKING_CREATE_SUCCESS";
export const BOOKING_CREATE_FAILURE = "BOOKING_CREATE_FAILURE";

export const CONCIERGE_QUOTE_REQUEST = "CONCIERGE_QUOTE_REQUEST";
export const CONCIERGE_QUOTE_SUCCESS = "CONCIERGE_QUOTE_SUCCESS";
export const CONCIERGE_QUOTE_FAILURE = "CONCIERGE_QUOTE_FAILURE";

export const CONCIERGE_CREATE_REQUEST = "CONCIERGE_CREATE_REQUEST";
export const CONCIERGE_CREATE_SUCCESS = "CONCIERGE_CREATE_SUCCESS";
export const CONCIERGE_CREATE_FAILURE = "CONCIERGE_CREATE_FAILURE";

export const SERVICES_FETCH_REQUEST = "SERVICES_FETCH_REQUEST";
export const SERVICES_FETCH_SUCCESS = "SERVICES_FETCH_SUCCESS";
export const SERVICES_FETCH_FAILURE = "SERVICES_FETCH_FAILURE";

export const MANAGED_ACCOUNT_REQUEST = "MANAGED_ACCOUNT_REQUEST";
export const MANAGED_ACCOUNT_FAILURE = "MANAGED_ACCOUNT_FAILURE";
export const MANAGED_ACCOUNT_SUCCESS = "MANAGED_ACCOUNT_SUCCESS";

export const BANK_STATUS_REQUEST = "BANK_STATUS_REQUEST";
export const BANK_STATUS_FAILURE = "BANK_STATUS_FAILURE";
export const BANK_STATUS_SUCCESS = "BANK_STATUS_SUCCESS";

export const PROJECT_FETCH_REQUEST = "PROJECT_FETCH_REQUEST";
export const PROJECT_FETCH_SUCCESS = "PROJECT_FETCH_SUCCESS";
export const PROJECT_FETCH_FAILURE = "PROJECT_FETCH_FAILURE";

export const PROJECT_BOARD_LISTINGS_FETCH_REQUEST =
  "PROJECT_BOARD_LISTINGS_FETCH_REQUEST";
export const PROJECT_BOARD_LISTINGS_FETCH_SUCCESS =
  "PROJECT_BOARD_LISTINGS_FETCH_SUCCESS";
export const PROJECT_BOARD_LISTINGS_FETCH_FAILURE =
  "PROJECT_BOARD_LISTINGS_FETCH_FAILURE";

export const PROJECT_BOARD_FETCH_REQUEST = "PROJECT_BOARD_FETCH_REQUEST";
export const PROJECT_BOARD_FETCH_SUCCESS = "PROJECT_BOARD_FETCH_SUCCESS";
export const PROJECT_BOARD_FETCH_FAILURE = "PROJECT_BOARD_FETCH_FAILURE";

export const PROJECT_UPDATE_REQUEST = "PROJECT_UPDATE_REQUEST";
export const PROJECT_UPDATE_SUCCESS = "PROJECT_UPDATE_SUCCESS";
export const PROJECT_UPDATE_FAILURE = "PROJECT_UPDATE_FAILURE";

export const PROJECT_BOARD_CREATE_SUCCESS = "PROJECT_BOARD_CREATE_SUCCESS";
export const PROJECT_BOARD_CREATE_REQUEST = "PROJECT_BOARD_CREATE_REQUEST";
export const PROJECT_BOARD_CREATE_FAILURE = "PROJECT_BOARD_CREATE_FAILURE";

export const PROJECT_BOARD_DELETE_SUCCESS = "PROJECT_BOARD_DELETE_SUCCESS";
export const PROJECT_BOARD_DELETE_REQUEST = "PROJECT_BOARD_DELETE_REQUEST";
export const PROJECT_BOARD_DELETE_FAILURE = "PROJECT_BOARD_DELETE_FAILURE";

export const PROJECT_BOARD_COPY_SUCCESS = "PROJECT_BOARD_COPY_SUCCESS";
export const PROJECT_BOARD_COPY_REQUEST = "PROJECT_BOARD_COPY_REQUEST";
export const PROJECT_BOARD_COPY_FAILURE = "PROJECT_BOARD_COPY_FAILURE";
export const CLEAR_PROJECT_BOARD_COPY_SUCCESS =
  "CLEAR_PROJECT_BOARD_COPY_SUCCESS";
export const CLEAR_PROJECT_BOARD_COPY_FAILURE =
  "CLEAR_PROJECT_BOARD_COPY_FAILURE";

export const PROJECT_ATTACHMENTS_UPDATE_SUCCESS =
  "PROJECT_ATTACHMENTS_UPDATE_SUCCESS";
export const PROJECT_ATTACHMENTS_UPDATE_REQUEST =
  "PROJECT_ATTACHMENTS_UPDATE_REQUEST";
export const PROJECT_ATTACHMENTS_UPDATE_FAILURE =
  "PROJECT_ATTACHMENTS_UPDATE_FAILURE";

export const PROJECT_ATTACHMENTS_FETCH_SUCCESS =
  "PROJECT_ATTACHMENTS_FETCH_SUCCESS";
export const PROJECT_ATTACHMENTS_FETCH_REQUEST =
  "PROJECT_ATTACHMENTS_FETCH_REQUEST";
export const PROJECT_ATTACHMENTS_FETCH_FAILURE =
  "PROJECT_ATTACHMENTS_FETCH_FAILURE";

export const PROJECT_ATTACHMENTS_CREATE_SUCCESS =
  "PROJECT_ATTACHMENTS_CREATE_SUCCESS";
export const PROJECT_ATTACHMENTS_CREATE_REQUEST =
  "PROJECT_ATTACHMENTS_CREATE_REQUEST";
export const PROJECT_ATTACHMENTS_CREATE_FAILURE =
  "PROJECT_ATTACHMENTS_CREATE_FAILURE";

export const PROJECT_ATTACHMENTS_DELETE_SUCCESS =
  "PROJECT_ATTACHMENTS_DELETE_SUCCESS";
export const PROJECT_ATTACHMENTS_DELETE_REQUEST =
  "PROJECT_ATTACHMENTS_DELETE_REQUEST";
export const PROJECT_ATTACHMENTS_DELETE_FAILURE =
  "PROJECT_ATTACHMENTS_DELETE_FAILURE";

export const FAVORITED_LISTINGS_FETCH_SUCCESS =
  "FAVORITED_LISTINGS_FETCH_SUCCESS";
export const FAVORITED_LISTINGS_FETCH_FAILURE =
  "FAVORITED_LISTINGS_FETCH_FAILURE";
export const FAVORITED_LISTINGS_FETCH_REQUEST =
  "FAVORITED_LISTINGS_FETCH_REQUEST";

export const ATTACHMENT_DETAIL_SUCCESS = "ATTACHMENT_DETAIL_SUCCESS";

export const RESET_ERROR_MESSAGE = "RESET_ERROR_MESSAGE";
export const RESET_ENV = "RESET_ENV";

export const SHOW_VARIABLE_PRICING_FORM = "SHOW_VARIABLE_PRICING_FORM";
export const SHOW_VARIABLE_ATTENDEE_FORM = "SHOW_VARIABLE_ATTENDEE_FORM";

export const LISTING_FETCH_REQUEST = "LISTING_FETCH_REQUEST";
export const LISTING_FETCH_SUCCESS = "LISTING_FETCH_SUCCESS";
export const LISTING_FETCH_FAILURE = "LISTING_FETCH_FAILURE";
export const LISTING_CLEAR_STORE = "LISTING_CLEAR_STORE";

export const LISTING_UPDATE_REQUEST = "LISTING_UPDATE_REQUEST";
export const LISTING_UPDATE_SUCCESS = "LISTING_UPDATE_SUCCESS";
export const LISTING_UPDATE_FAILURE = "LISTING_UPDATE_FAILURE";

export const LISTING_PRICING_FETCH_REQUEST = "LISTING_PRICING_FETCH_REQUEST";
export const LISTING_PRICING_FETCH_SUCCESS = "LISTING_PRICING_FETCH_SUCCESS";
export const LISTING_PRICING_FETCH_FAILURE = "LISTING_PRICING_FETCH_FAILURE";
export const LISTING_PRICING_CLEAR_STORE = "LISTING_PRICING_CLEAR_STORE";

export const PRICE_UPDATE_REQUEST = "PRICE_UPDATE_REQUEST";
export const PRICE_UPDATE_SUCCESS = "PRICE_UPDATE_SUCCESS";
export const PRICE_UPDATE_FAILURE = "PRICE_UPDATE_FAILURE";

export const CALENDAR_PRICING_FETCH_REQUEST = "CALENDAR_PRICING_FETCH_REQUEST";
export const CALENDAR_PRICING_FETCH_SUCCESS = "CALENDAR_PRICING_FETCH_SUCCESS";
export const CALENDAR_PRICING_FETCH_FAILURE = "CALENDAR_PRICING_FETCH_FAILURE";
export const CALENDAR_PRICING_CLEAR_STORE = "CALENDAR_PRICING_CLEAR_STORE";

export const CALENDAR_PRICING_UPDATE_REQUEST =
  "CALENDAR_PRICING_UPDATE_REQUEST";
export const CALENDAR_PRICING_UPDATE_SUCCESS =
  "CALENDAR_PRICING_UPDATE_SUCCESS";
export const CALENDAR_PRICING_UPDATE_FAILURE =
  "CALENDAR_PRICING_UPDATE_FAILURE";

export const CALENDAR_PRICING_DELETE_REQUEST =
  "CALENDAR_PRICING_DELETE_REQUEST";
export const CALENDAR_PRICING_DELETE_SUCCESS =
  "CALENDAR_PRICING_DELETE_SUCCESS";
export const CALENDAR_PRICING_DELETE_FAILURE =
  "CALENDAR_PRICING_DELETE_FAILURE";

export const CALENDAR_PRICING_CREATE_REQUEST =
  "CALENDAR_PRICING_CREATE_REQUEST";
export const CALENDAR_PRICING_CREATE_SUCCESS =
  "CALENDAR_PRICING_CREATE_SUCCESS";
export const CALENDAR_PRICING_CREATE_FAILURE =
  "CALENDAR_PRICING_CREATE_FAILURE";

export const LISTINGS_FETCH_REQUEST = "LISTINGS_FETCH_REQUEST";
export const LISTINGS_FETCH_SUCCESS = "LISTINGS_FETCH_SUCCESS";
export const LISTINGS_FETCH_FAILURE = "LISTINGS_FETCH_FAILURE";
export const LISTINGS_CLEAR_STORE = "LISTING_CLEAR_STORE";

export const LISTINGS_FETCH_BY_SPACE_REQUEST =
  "LISTINGS_FETCH_BY_SPACE_REQUEST";
export const LISTINGS_FETCH_BY_SPACE_SUCCESS =
  "LISTINGS_FETCH_BY_SPACE_SUCCESS";
export const LISTINGS_FETCH_BY_SPACE_FAILURE =
  "LISTINGS_FETCH_BY_SPACE_FAILURE";

export const LISTINGS_FETCH_BY_OWNER_SPACES_SUCCESS =
  "LISTINGS_FETCH_BY_OWNER_SPACES_SUCCESS";

export const SPACE_CLEAR_STORE = "SPACE_CLEAR_STORE";
export const SPACE_FETCH_REQUEST = "SPACE_FETCH_REQUEST";
export const SPACE_FETCH_SUCCESS = "SPACE_FETCH_SUCCESS";
export const SPACE_FETCH_FAILURE = "SPACE_FETCH_FAILURE";

export const SPACE_FETCH_FAQ_SUCCESS = "SPACE_FETCH_FAQ_SUCCESS";
export const SPACE_FETCH_FAQ_FAILURE = "SPACE_FETCH_FAQ_FAILURE";

export const SPACE_UPDATE_FAQ_SUCCESS = "SPACE_UPDATE_FAQ_SUCCESS";

export const SPACE_COMPLETION_STATUS_FETCH_REQUEST =
  "SPACE_COMPLETION_STATUS_FETCH_REQUEST";
export const SPACE_COMPLETION_STATUS_FETCH_SUCCESS =
  "SPACE_COMPLETION_STATUS_FETCH_SUCCESS";
export const SPACE_COMPLETION_STATUS_FETCH_FAILURE =
  "SPACE_COMPLETION_STATUS_FETCH_FAILURE";

export const SPACE_COUNTRY_STATUS_FETCH_REQUEST =
  "SPACE_COUNTRY_STATUS_FETCH_REQUEST";
export const SPACE_COUNTRY_STATUS_FETCH_SUCCESS =
  "SPACE_COUNTRY_STATUS_FETCH_SUCCESS";
export const SPACE_COUNTRY_STATUS_FETCH_FAILURE =
  "SPACE_COUNTRY_STATUS_FETCH_FAILURE";

export const SPACE_TAGS_CLEAR_STORE = "SPACE_TAGS_CLEAR_STORE";
export const SPACE_TAGS_FETCH_REQUEST = "SPACE_TAGS_FETCH_REQUEST";
export const SPACE_TAGS_FETCH_SUCCESS = "SPACE_TAGS_FETCH_SUCCESS";
export const SPACE_TAGS_FETCH_FAILURE = "SPACE_TAGS_FETCH_FAILURE";

export const SPACES_CLEAR_STORE = "SPACES_CLEAR_STORE";
export const SPACES_FETCH_REQUEST = "SPACES_FETCH_REQUEST";
export const SPACES_FETCH_SUCCESS = "SPACES_FETCH_SUCCESS";
export const SPACES_FETCH_FAILURE = "SPACES_FETCH_FAILURE";

export const SPACE_METROS_FETCH_REQUEST = "SPACE_METROS_FETCH_REQUEST";
export const SPACE_METROS_FETCH_SUCCESS = "SPACE_METROS_FETCH_SUCCESS";
export const SPACE_METROS_FETCH_FAILURE = "SPACE_METROS_FETCH_FAILURE";

export const SPACE_UPDATE_REQUEST = "SPACE_UPDATE_REQUEST";
export const SPACE_UPDATE_SUCCESS = "SPACE_UPDATE_SUCCESS";
export const SPACE_UPDATE_FAILURE = "SPACE_UPDATE_FAILURE";

export const SPACE_CREATE_REQUEST = "SPACE_CREATE_REQUEST";
export const SPACE_CREATE_SUCCESS = "SPACE_CREATE_SUCCESS";
export const SPACE_CREATE_FAILURE = "SPACE_CREATE_FAILURE";

export const CALENDAR_SPACES_FETCH_REQUEST = "CALENDAR_SPACES_FETCH_REQUEST";
export const CALENDAR_SPACES_FETCH_SUCCESS = "CALENDAR_SPACES_FETCH_SUCCESS";
export const CALENDAR_SPACES_FETCH_FAILURE = "CALENDAR_SPACES_FETCH_FAILURE";

export const SPACES_SELECT = "SPACES_SELECT";
export const DATE_SELECT = "DATE_SELECT";

export const CALENDAR_FETCH_REQUEST = "CALENDAR_FETCH_REQUEST";
export const CALENDAR_FETCH_SUCCESS = "CALENDAR_FETCH_SUCCESS";
export const CALENDAR_FETCH_FAILURE = "CALENDAR_FETCH_FAILURE";

export const DAY_EVENTS_FETCH_REQUEST = "DAY_EVENTS_FETCH_REQUEST";
export const DAY_EVENTS_FETCH_SUCCESS = "DAY_EVENTS_FETCH_SUCCESS";
export const DAY_EVENTS_FETCH_FAILURE = "DAY_EVENTS_FETCH_FAILURE";
export const RESET_DAY_EVENTS = "RESET_DAY_EVENTS";

export const POST_BLOCK_DAY_REQUEST = "POST_BLOCK_DAY_REQUEST";
export const POST_BLOCK_DAY_SUCCESS = "POST_BLOCK_DAY_SUCCESS";
export const POST_BLOCK_DAY_FAILURE = "POST_BLOCK_DAY_FAILURE";

export const DELETE_BLOCK_DAY_REQUEST = "DELETE_BLOCK_DAY_REQUEST";
export const DELETE_BLOCK_DAY_SUCCESS = "DELETE_BLOCK_DAY_SUCCESS";
export const DELETE_BLOCK_DAY_FAILURE = "DELETE_BLOCK_DAY_FAILURE";

export const FETCH_NUX_REQUEST = "FETCH_NUX_REQUEST";
export const FETCH_NUX_SUCCESS = "FETCH_NUX_SUCCESS";
export const FETCH_NUX_FAILURE = "FETCH_NUX_FAILURE";

export const SYNC_REQUEST = "SYNC_REQUEST";
export const SYNC_SUCCESS = "SYNC_SUCCESS";
export const SYNC_FAILURE = "SYNC_FAILURE";

export const CALENDAR_SYNC_FETCH_REQUEST = "CALENDAR_SYNC_FETCH_REQUEST";
export const CALENDAR_SYNC_FETCH_SUCCESS = "CALENDAR_SYNC_FETCH_SUCCESS";
export const CALENDAR_SYNC_FETCH_FAILURE = "CALENDAR_SYNC_FETCH_FAILURE";

export const OPHOURS_FETCH_REQUEST = "OPHOURS_FETCH_REQUEST";
export const OPHOURS_FETCH_SUCCESS = "OPHOURS_FETCH_SUCCESS";
export const OPHOURS_FETCH_FAILURE = "OPHOURS_FETCH_FAILURE";

export const OPHOURS_POST_REQUEST = "OPHOURS_POST_REQUEST";
export const OPHOURS_POST_SUCCESS = "OPHOURS_POST_SUCCESS";
export const OPHOURS_POST_FAILURE = "OPHOURS_POST_FAILURE";

export const INVENTORY_ITEM_STORE = "INVENTORY_ITEM_STORE";
export const INVENTORY_FETCH_REQUEST = "INVENTORY_ITEMS_FETCH_REQUEST";
export const INVENTORY_FETCH_SUCCESS = "INVENTORY_ITEMS_FETCH_SUCCESS";
export const INVENTORY_FETCH_FAILURE = "INVENTORY_ITEMS_FETCH_FAILURE";
export const RESET_INVENTORY_STORE = "RESET_INVENTORY_STORE";

export const INVENTORY_ITEM_FETCH_REQUEST = "INVENTORY_ITEM_FETCH_REQUEST";
export const INVENTORY_ITEM_FETCH_SUCCESS = "INVENTORY_ITEM_FETCH_SUCCESS";
export const INVENTORY_ITEM_FETCH_FAILURE = "INVENTORY_ITEM_FETCH_FAILURE";

export const INVENTORY_ITEM_CREATE_REQUEST = "INVENTORY_ITEM_CREATE_REQUEST";
export const INVENTORY_ITEM_CREATE_SUCCESS = "INVENTORY_ITEM_CREATE_SUCCESS";
export const INVENTORY_ITEM_CREATE_FAILURE = "INVENTORY_ITEM_CREATE_FAILURE";

export const INVENTORY_ITEM_UPDATE_REQUEST = "INVENTORY_ITEM_UPDATE_REQUEST";
export const INVENTORY_ITEM_UPDATE_SUCCESS = "INVENTORY_ITEM_UPDATE_SUCCESS";
export const INVENTORY_ITEM_UPDATE_FAILURE = "INVENTORY_ITEM_UPDATE_FAILURE";

export const INVENTORY_ITEM_DELETE_REQUEST = "INVENTORY_ITEM_DELETE_REQUEST";
export const INVENTORY_ITEM_DELETE_SUCCESS = "INVENTORY_ITEM_DELETE_SUCCESS";
export const INVENTORY_ITEM_DELETE_FAILURE = "INVENTORY_ITEM_DELETE_FAILURE";

export const FETCH_SYNC_STATUS_REQUEST = "FETCH_SYNC_STATUS_REQUEST";
export const FETCH_SYNC_STATUS_FAILURE = "FETCH_SYNC_STATUS_FAILURE";
export const FETCH_SYNC_STATUS_SUCCESS = "FETCH_SYNC_STATUS_SUCCESS";

export const UPDATE_NUX_SUCCESS = "UPDATE_NUX_SUCCESS";

export const ENV_FETCH_REQUEST = "ENV_FETCH_REQUEST";
export const ENV_FETCH_SUCCESS = "ENV_FETCH_SUCCESS";
export const ENV_FETCH_FAILURE = "ENV_FETCH_FAILURE";

export const REVIEW_FETCH_REQUEST = "REVIEW_FETCH_REQUEST";
export const REVIEW_FETCH_SUCCESS = "REVIEW_FETCH_SUCCESS";
export const REVIEW_FETCH_FAILURE = "REVIEW_FETCH_FAILURE";

export const REVIEW_UPDATE_REQUEST = "REVIEW_UPDATE_REQUEST";
export const REVIEW_UPDATE_SUCCESS = "REVIEW_UPDATE_SUCCESS";
export const REVIEW_UPDATE_FAILURE = "REVIEW_UPDATE_FAILURE";

export const TOGGLE_MODAL = "TOGGLE_MODAL";

export const ENV_ADDONS_FETCH_REQUEST = "ENV_ADDONS_REQUEST";
export const ENV_ADDONS_FETCH_SUCCESS = "ENV_ADDONS_SUCCESS";
export const ENV_ADDONS_FETCH_FAILURE = "ENV_ADDONS_FAILURE";

export const PAYLOAD_FETCH_REQUEST = "PAYLOAD_FETCH_REQUEST";
export const PAYLOAD_FETCH_SUCCESS = "PAYLOAD_FETCH_SUCCESS";
export const PAYLOAD_FETCH_FAILURE = "PAYLOAD_FETCH_FAILURE";

export const PAYLOAD_UPDATE_REQUEST = "PAYLOAD_UPDATE_REQUEST";
export const PAYLOAD_UPDATE_SUCCESS = "PAYLOAD_UPDATE_SUCCESS";
export const PAYLOAD_UPDATE_FAILURE = "PAYLOAD_UPDATE_FAILURE";

export const PAYLOAD_CLEAR_STORE = "PAYLOAD_CLEAR_STORE";

export const FLOW_PROGRESS_UPDATE = "FLOW_PROGRESS_UPDATE";
export const FLOW_PROGRESS_RESET = "FLOW_PROGRESS_RESET";

export const ADDONS_INDEX_UPDATE = "ADDONS_INDEX_UPDATE";
export const ADDONS_STEP_UPDATE = "ADDONS_STEP_UPDATE";
export const ADDONS_ADD_ITEM = "ADDONS_ADD_ITEM";

export const OFFER_QUOTE_CREATE_REQUEST = "OFFER_QUOTE_CREATE_REQUEST";
export const OFFER_QUOTE_CREATE_SUCCESS = "OFFER_QUOTE_CREATE_SUCCESS";
export const OFFER_QUOTE_CREATE_FAILURE = "OFFER_QUOTE_CREATE_FAILURE";

export const OFFER_CREATE_REQUEST = "OFFER_CREATE_REQUEST";
export const OFFER_CREATE_SUCCESS = "OFFER_CREATE_SUCCESS";
export const OFFER_CREATE_FAILURE = "OFFER_CREATE_FAILURE";

export const OFFER_WITHDRAW_REQUEST = "OFFER_WITHDRAW_REQUEST";
export const OFFER_WITHDRAW_SUCCESS = "OFFER_WITHDRAW_SUCCESS";
export const OFFER_WITHDRAW_FAILURE = "OFFER_WITHDRAW_FAILURE";

export const OFFER_ACCEPT_REQUEST = "OFFER_ACCEPT_REQUEST";
export const OFFER_ACCEPT_SUCCESS = "OFFER_ACCEPT_SUCCESS";
export const OFFER_ACCEPT_FAILURE = "OFFER_ACCEPT_FAILURE";

export const OFFER_DECLINE_REQUEST = "OFFER_DECLINE_REQUEST";
export const OFFER_DECLINE_SUCCESS = "OFFER_DECLINE_SUCCESS";
export const OFFER_DECLINE_FAILURE = "OFFER_DECLINE_FAILURE";

export const RESET_CONTRACT_STORE = "RESET_CONTRACT_STORE";

export const CONTRACTS_FETCH_REQUEST = "CONTRACTS_FETCH_REQUEST";
export const CONTRACTS_FETCH_SUCCESS = "CONTRACTS_FETCH_SUCCESS";
export const CONTRACTS_FETCH_FAILURE = "CONTRACTS_FETCH_FAILURE";

export const HOST_UPDATE_QUOTE_REQUEST = "HOST_UPDATE_QUOTE_REQUEST";
export const HOST_UPDATE_QUOTE_SUCCESS = "HOST_UPDATE_QUOTE_SUCCESS";
export const HOST_UPDATE_QUOTE_FAILURE = "HOST_UPDATE_QUOTE_FAILURE";

export const HOST_UPDATE_CREATE_REQUEST = "HOST_UPDATE_CREATE_REQUEST";
export const HOST_UPDATE_CREATE_SUCCESS = "HOST_UPDATE_CREATE_SUCCESS";
export const HOST_UPDATE_CREATE_FAILURE = "HOST_UPDATE_CREATE_FAILURE";

export const HOST_UPDATE_DECLINE_REQUEST = "HOST_UPDATE_DECLINE_REQUEST";
export const HOST_UPDATE_DECLINE_SUCCESS = "HOST_UPDATE_DECLINE_SUCCESS";
export const HOST_UPDATE_DECLINE_FAILURE = "HOST_UPDATE_DECLINE_FAILURE";

export const HOST_UPDATE_ACCEPT_REQUEST = "HOST_UPDATE_ACCEPT_REQUEST";
export const HOST_UPDATE_ACCEPT_SUCCESS = "HOST_UPDATE_ACCEPT_SUCCESS";
export const HOST_UPDATE_ACCEPT_FAILURE = "HOST_UPDATE_ACCEPT_FAILURE";

export const GUEST_UPDATE_QUOTE_REQUEST = "GUEST_UPDATE_QUOTE_REQUEST";
export const GUEST_UPDATE_QUOTE_SUCCESS = "GUEST_UPDATE_QUOTE_SUCCESS";
export const GUEST_UPDATE_QUOTE_FAILURE = "GUEST_UPDATE_QUOTE_FAILURE";

export const GUEST_UPDATE_CREATE_REQUEST = "GUEST_UPDATE_CREATE_REQUEST";
export const GUEST_UPDATE_CREATE_SUCCESS = "GUEST_UPDATE_CREATE_SUCCESS";
export const GUEST_UPDATE_CREATE_FAILURE = "GUEST_UPDATE_CREATE_FAILURE";

export const GUEST_UPDATE_ACCEPT_REQUEST = "GUEST_UPDATE_ACCEPT_REQUEST";
export const GUEST_UPDATE_ACCEPT_SUCCESS = "GUEST_UPDATE_ACCEPT_SUCCESS";
export const GUEST_UPDATE_ACCEPT_FAILURE = "GUEST_UPDATE_ACCEPT_FAILURE";

export const GUEST_UPDATE_WITHDRAW_REQUEST = "GUEST_UPDATE_WITHDRAW_REQUEST";
export const GUEST_UPDATE_WITHDRAW_SUCCESS = "GUEST_UPDATE_WITHDRAW_SUCCESS";
export const GUEST_UPDATE_WITHDRAW_FAILURE = "GUEST_UPDATE_WITHDRAW_FAILURE";

export const CONTRACTS_SNAPSHOT_FETCH_REQUEST =
  "CONTRACTS_SNAPSHOT_FETCH_REQUEST";
export const CONTRACTS_SNAPSHOT_FETCH_SUCCESS =
  "CONTRACTS_SNAPSHOT_FETCH_SUCCESS";
export const CONTRACTS_SNAPSHOT_FETCH_FAILURE =
  "CONTRACTS_SNAPSHOT_FETCH_FAILURE";

export const PAYOUTS_FETCH_REQUEST = "PAYOUTS_FETCH_REQUEST";
export const PAYOUTS_FETCH_SUCCESS = "PAYOUTS_FETCH_SUCCESS";
export const PAYOUTS_PENDING_FETCH_SUCCESS = "PAYOUTS_PENDING_FETCH_SUCCESS";
export const PAYOUTS_FETCH_FAILURE = "PAYOUTS_FETCH_FAILURE";
export const CSV_FETCHING = "CSV_FETCHING";

export const WORKFLOWS_FETCH_REQUEST = "WORKFLOWS_FETCH_REQUEST";
export const WORKFLOWS_FETCH_SUCCESS = "WORKFLOWS_FETCH_SUCCESS";
export const WORKFLOWS_FETCH_FAILURE = "WORKFLOWS_FETCH_FAILURE";

export const VENDORS_FETCH_REQUEST = "VENDORS_FETCH_REQUEST";
export const VENDORS_FETCH_SUCCESS = "VENDORS_FETCH_SUCCESS";
export const VENDORS_FETCH_FAILURE = "VENDORS_FETCH_FAILURE";

export const TOGGLE_BANNER = "TOGGLE_BANNER";
export const CLEAR_BANNER = "CLEAR_BANNER";

export const BILLING_CREATE_REQUEST = "BILLING_CREATE_REQUEST";
export const BILLING_CREATE_SUCCESS = "BILLING_CREATE_SUCCESS";
export const BILLING_CREATE_FAILURE = "BILLING_CREATE_FAILURE";

export const BILLING_FETCH_REQUEST = "BILLING_FETCH_REQUEST";
export const BILLING_FETCH_SUCCESS = "BILLING_FETCH_SUCCESS";
export const BILLING_FETCH_FAILURE = "BILLING_FETCH_FAILURE";

export const BILLING_UPDATE_REQUEST = "BILLING_UPDATE_REQUEST";
export const BILLING_UPDATE_SUCCESS = "BILLING_UPDATE_SUCCESS";
export const BILLING_UPDATE_FAILURE = "BILLING_UPDATE_FAILURE";

export const VAT_CREATE_REQUEST = "VAT_CREATE_REQUEST";
export const VAT_CREATE_SUCCESS = "VAT_CREATE_SUCCESS";
export const VAT_CREATE_FAILURE = "VAT_CREATE_FAILURE";

export const VAT_FETCH_REQUEST = "VAT_FETCH_REQUEST";
export const VAT_FETCH_SUCCESS = "VAT_FETCH_SUCCESS";
export const VAT_FETCH_FAILURE = "VAT_FETCH_FAILURE";

export const VAT_UPDATE_REQUEST = "VAT_UPDATE_REQUEST";
export const VAT_UPDATE_SUCCESS = "VAT_UPDATE_SUCCESS";
export const VAT_UPDATE_FAILURE = "VAT_UPDATE_FAILURE";

export const VAT_REMOVE_REQUEST = "VAT_REMOVE_REQUEST";
export const VAT_REMOVE_SUCCESS = "VAT_REMOVE_SUCCESS";
export const VAT_REMOVE_FAILURE = "VAT_REMOVE_FAILURE";

export const FEE_PROFILES_FETCH_REQUEST = "FEE_PROFILES_FETCH_REQUEST";
export const FEE_PROFILES_FETCH_SUCCESS = "FEE_PROFILES_FETCH_SUCCESS";
export const FEE_PROFILES_FETCH_FAILURE = "FEE_PROFILES_FETCH_FAILURE";

export const REGIONAL_FEES_FETCH_REQUEST = "REGIONAL_FEES_FETCH_REQUEST";
export const REGIONAL_FEES_FETCH_SUCCESS = "REGIONAL_FEES_FETCH_SUCCESS";
export const REGIONAL_FEES_FETCH_FAILURE = "REGIONAL_FEES_FETCH_FAILURE";

export const INVOICES_BY_YEAR_REQUEST = "INVOICES_BY_YEAR_REQUEST";
export const INVOICES_BY_YEAR_SUCCESS = "INVOICES_BY_YEAR_SUCCESS";
export const INVOICES_BY_YEAR_FAILURE = "INVOICES_BY_YEAR_FAILURE";

export const INVOICES_FETCH_REQUEST = "INVOICES_FETCH_REQUEST";
export const INVOICES_FETCH_SUCCESS = "INVOICES_FETCH_SUCCESS";
export const INVOICES_FETCH_FAILURE = "INVOICES_FETCH_FAILURE";

export const INVOICES_YEARS_FETCH_REQUEST = "INVOICES_YEARS_FETCH_REQUEST";
export const INVOICES_YEARS_FETCH_SUCCESS = "INVOICES_YEARS_FETCH_SUCCESS";
export const INVOICES_YEARS_FETCH_FAILURE = "INVOICES_YEARS_FETCH_FAILURE";

export const INVOICE_ENTRIES_FETCH_REQUEST = "INVOICE_ENTRIES_FETCH_REQUEST";
export const INVOICE_ENTRIES_FETCH_SUCCESS = "INVOICE_ENTRIES_FETCH_SUCCESS";
export const INVOICE_ENTRIES_FETCH_FAILURE = "INVOICE_ENTRIES_FETCH_FAILURE";

export const FETCH_ADDRESS_BY_ID_REQUEST = "FETCH_ADDRESS_BY_ID_REQUEST";
export const FETCH_ADDRESS_BY_ID_SUCCESS = "FETCH_ADDRESS_BY_ID_SUCCESS";
export const FETCH_ADDRESS_BY_ID_FAILURE = "FETCH_ADDRESS_BY_ID_FAILURE";

export const INVOICE_ENTRIES_BY_TYPE_REQUEST =
  "INVOICE_ENTRIES_BY_TYPE_REQUEST";
export const INVOICE_ENTRIES_BY_TYPE_SUCCESS =
  "INVOICE_ENTRIES_BY_TYPE_SUCCESS";
export const INVOICE_ENTRIES_BY_TYPE_FAILURE =
  "INVOICE_ENTRIES_BY_TYPE_FAILURE";

export const INVOICE_FETCH_SPACE_RENTALS_REQUEST =
  "INVOICE_FETCH_SPACE_RENTALS_REQUEST";
export const INVOICE_FETCH_SPACE_RENTALS_SUCCESS =
  "INVOICE_FETCH_SPACE_RENTALS_SUCCESS";
export const INVOICE_FETCH_SPACE_RENTALS_FAILURE =
  "INVOICE_FETCH_SPACE_RENTALS_FAILURE";
